/**
 * Safe deep merge that never calls Object.keys on undefined/null (avoids deepmerge throwing).
 */
function safeDeepMerge(target, source) {
  if (target == null || typeof target !== 'object' || Array.isArray(target)) {
    return source != null && typeof source === 'object' && !Array.isArray(source) ? { ...source } : {};
  }
  if (source == null || typeof source !== 'object' || Array.isArray(source)) {
    return { ...target };
  }
  const out = { ...target };
  const sourceKeys = Object.keys(source);
  for (let i = 0; i < sourceKeys.length; i += 1) {
    const k = sourceKeys[i];
    const srcVal = source[k];
    const tgtVal = target[k];
    if (
      srcVal != null && typeof srcVal === 'object' && !Array.isArray(srcVal)
      && tgtVal != null && typeof tgtVal === 'object' && !Array.isArray(tgtVal)
    ) {
      out[k] = safeDeepMerge(tgtVal, srcVal);
    } else if (srcVal !== undefined) {
      out[k] = srcVal;
    }
  }
  return out;
}

function toMessagesObject(value) {
  if (value == null || typeof value !== 'object' || Array.isArray(value)) return {};
  return value;
}

export default class I18nTranslationMessageLoader {
  static load({ locale }) {
    /* Loading translations from the "main" locale place */
    const translationMessages = {};

    const mainTranslations = require.context('Locales/full', false, /.yml$/);
    const defaultAndCurrentLocaleRegexp = new RegExp(`^(en|${locale})`);

    (mainTranslations.keys() || []).forEach((pathName) => {
      const localeName = pathName.substring(2, pathName.length - 4);
      // we only want to load default en.yml locale and locale chosen by user only
      if (defaultAndCurrentLocaleRegexp.test(localeName)) {
        /* pathName is in the form of `./locale_name.yml` */
        const payload = mainTranslations(pathName);
        const messages = payload && (payload[localeName] ?? payload);
        if (messages != null && typeof messages === 'object') {
          translationMessages[localeName] = messages;
        }
      }
    });

    const newEnTranslation = require.context('Locales/new', false);
    (newEnTranslation.keys() || []).forEach((pathName) => {
      const module = newEnTranslation(pathName);
      if (module) {
        translationMessages.en = safeDeepMerge(
          toMessagesObject(translationMessages.en),
          toMessagesObject(module.en),
        );
      }
    });

    const aliasedEnTranslation = require.context('Locales/', false, /aliases.en.yml$/);
    (aliasedEnTranslation.keys() || []).forEach((pathName) => {
      const module = aliasedEnTranslation(pathName);
      if (module) {
        translationMessages.en = safeDeepMerge(
          toMessagesObject(translationMessages.en),
          toMessagesObject(module.en),
        );
      }
    });
    return translationMessages;
  }
}
